import { Box, Typography } from "@mui/material";
import React from "react";

const PerformanceRatings = () => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 800, color: "#146ED2" }}>
        Performance Rating
      </Typography>
      <Box sx={{ opacity: 0.5 }}>
        <Typography sx={{ mb: 1, fontWeight: 800 }}>
          Rate the staff memeber's performance for each objective on a scale of 0-4
        </Typography>
        <Typography sx={{ fontWeight: 800 }}>0 - Unsatisfactory</Typography>
        <Typography sx={{ fontWeight: 800 }}>1 - Partial</Typography>
        <Typography sx={{ fontWeight: 800 }}>2 - Achieve</Typography>
        <Typography sx={{ fontWeight: 800 }}>3 - Exceed</Typography>
        <Typography sx={{ fontWeight: 800 }}>4 - Exceptional</Typography>
      </Box>
    </Box>
  );
};

export default PerformanceRatings;
